import * as React from 'react';
import { Button } from 'src/shadcn/components/ui/button';
import { useSidebarSetingsMenuEmployeeLogoutButtonState } from './useSidebarSetingsMenuEmployeeLogoutButtonState';
import { RotateCw } from 'lucide-react';
import { useLoginAsShop } from '../useLoginAsShopFromEmployee';

export interface ISidebarSettingsMenuEmployeeLogoutButtonProps {
  state: ReturnType<typeof useSidebarSetingsMenuEmployeeLogoutButtonState>;
}

export const SidebarSettingsMenuEmployeeLogoutButton: React.FunctionComponent<
  ISidebarSettingsMenuEmployeeLogoutButtonProps
> = props => {
  const { loginAsShop, isLoggingAsShop } = useLoginAsShop();
  return (
    <>
      {props.state.currentShift && (
        <Button
          variant={'destructive'}
          onClick={() => {
            props.state.endShift(() => loginAsShop());
          }}
          disabled={
            props.state.isGettingShift ||
            props.state.isEndingShift ||
            isLoggingAsShop
          }
        >
          <span>End shift and log out</span>
          {props.state.isEndingShift && (
            <RotateCw className='ml-2 h-4 w-4 animate-spin' />
          )}
        </Button>
      )}
      <Button
        variant={props.state.currentShift ? 'secondary' : 'destructive'}
        onClick={() => {
          loginAsShop();
        }}
        disabled={
          props.state.isGettingShift ||
          props.state.isEndingShift ||
          isLoggingAsShop
        }
      >
        <span>
          {props.state.currentShift
            ? 'Keep shift running & log out'
            : 'Log out'}
        </span>
        {props.state.isEndingShift && (
          <RotateCw className='ml-2 h-4 w-4 animate-spin' />
        )}
      </Button>
    </>
  );
};
